var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchEntBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    viewBox: "0 0 40 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 16,
    rx: 8,
    fill: "#90A0B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.001 6C33.001 5.72386 32.7771 5.5 32.501 5.5C32.2248 5.5 32.001 5.72386 32.001 6V8.5C32.001 8.77614 31.7771 9 31.501 9H29.001V7.99993C29.001 7.58791 28.5306 7.35272 28.201 7.59993L26.201 9.09993C25.8166 9.38824 26.0205 9.99993 26.501 9.99993H26.9926C26.9954 9.99998 26.9982 10 27.001 10H31.501C32.3294 10 33.001 9.32843 33.001 8.5V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.728 11H13.448V10.008H10.912V8.424H12.992V7.432H10.912V6.064H13.36V5.08H9.728V11ZM14.6499 11H15.7699V8.624C15.7699 7.944 15.6819 7.2 15.6259 6.56H15.6659L16.2659 7.832L17.9779 11H19.1779V5.08H18.0579V7.44C18.0579 8.112 18.1459 8.896 18.2099 9.512H18.1699L17.5779 8.232L15.8579 5.08H14.6499V11ZM21.8181 11H23.0021V6.064H24.6821V5.08H20.1541V6.064H21.8181V11Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEntBtn);
export default __webpack_public_path__ + "static/media/search_ent_btn.1eb1e3a0353796a605c1f2f944fe2409.svg";
export { ForwardRef as ReactComponent };